
import HttpClient from '../HttpService';

function list(page, limit, data) {
    return HttpClient.post(`/certificate-templates/list?page=${page}&limit=${limit}`, data);
}

function getById(id) {
    return HttpClient.get(`/certificate-templates/${id}`);
}

function create(data) {
    return HttpClient.post(`/certificate-templates`, data);
}

function update(id, data) {
    return HttpClient.put(`/certificate-templates/${id}`, data);
}

function destroy(id) {
    return HttpClient.delete(`/certificate-templates/${id}`);
}

export default {
    list,
    getById,
    create,
    update,
    destroy
}
